import React, { Suspense, useEffect, useState } from 'react';
import { InputSkeleton } from '../components/loading/input-skeleton';

export const withLazyComponent = (LazyComponent, LoadingComponent) => {
  const [loadingComponent, setLoadingComponent] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      setLoadingComponent((LoadingComponent && <LoadingComponent />) ?? <InputSkeleton />);
    }, 5);
  }, []);

  return (props) => (
    <Suspense fallback={loadingComponent}>
      <LazyComponent {...props} />
    </Suspense>
  );
};
